import { useState } from 'react';
import SchemaForm, { FormField } from '../../components/Forms/SchemaForm';
import VerificationPageLayout from '../../components/Layout/VerificationPageLayout';
import VerificationResultDisplay from '../../components/Verification/VerificationResultDisplay';
import { faceviewPlusService, faceviewPlusSchema } from '../../services/verificationSystemServices/faceviewPlusService';
import { Alert, Box, CircularProgress } from '@mui/material';

const FaceviewPlus = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [result, setResult] = useState<any>(null);
    const [error, setError] = useState<string | null>(null);

    const handleSubmit = async (data: any) => {
        const payload = faceviewPlusService.createPayload(data);
        setIsLoading(true);
        setError(null);
        setResult(null);

        try {
            const response = await faceviewPlusService.executeReport(payload);
            setResult(response);
        } catch (err: any) {
            setError(err.response?.data?.detail || err.message || 'An error occurred during verification');
        } finally {
            setIsLoading(false);
        }
    };

    const formSchema: FormField[] = [
        { name: 'idNumber', label: 'ID Number', type: 'text', gridProps: { xs: 12, md: 6 }, required: true, maxLength: 13 },
        { name: 'firstName', label: 'First Name', type: 'text', gridProps: { xs: 12, md: 6 }, required: false },
        { name: 'surname', label: 'Surname', type: 'text', gridProps: { xs: 12, md: 6 }, required: false },
        { name: 'voucherCode', label: 'Voucher Code', type: 'text', gridProps: { xs: 12, md: 6 }, required: false },
        { name: 'yourReference', label: 'Your Reference', type: 'text', gridProps: { xs: 12, md: 6 }, required: false },
    ];

    return (
        <VerificationPageLayout title="Faceview Plus">
            <Box mb={4}>
                <SchemaForm
                    schema={formSchema}
                    onSubmit={handleSubmit}
                    submitLabel={isLoading ? 'Verifying…' : 'Verify'}
                    validationSchema={faceviewPlusSchema}
                />
            </Box>

            {isLoading && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 2 }}>
                    <CircularProgress sx={{ color: '#2D4677' }} />
                </Box>
            )}

            {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}

            {result && !isLoading && (
                <VerificationResultDisplay
                    title="Faceview Plus"
                    requestId={result.request_id}
                    success={result.success}
                    message={result.message}
                    data={result.report_data ?? null}
                />
            )}
        </VerificationPageLayout>
    );
};

export default FaceviewPlus;
